import { render, staticRenderFns } from "./registorpage.vue?vue&type=template&id=e9c98094&scoped=true&"
import script from "./registorpage.vue?vue&type=script&lang=js&"
export * from "./registorpage.vue?vue&type=script&lang=js&"
import style0 from "./registorpage.vue?vue&type=style&index=0&id=e9c98094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c98094",
  null
  
)

export default component.exports